/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetAuthorizedAccountRequest} from '@cash-web/protos/squareup/cash/janus/api/JanusService.pb'
import {GetAuthorizedAccountResponse} from '@cash-web/protos/squareup/cash/janus/api/JanusService.pb'


export const getAuthorizedAccount = (request: GetAuthorizedAccountRequest, options?: CashRequestOptions) => post<GetAuthorizedAccountRequest, GetAuthorizedAccountResponse>("/2.0/cash/get-authorized-account", request, {...options, rejectOnError: true })